import { NgModule } from '@angular/core';
import { ThemeComponent } from './theme.component';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../auth/_guards/auth.guard';
import { EditArtistModule } from "./pages/default/editArtist/editArtist.module";
import { FileUploadModule } from "./layouts/file-upload/file-upload.module";

const routes: Routes = [
    {
        'path': '',
        'component': ThemeComponent,
        'canActivate': [AuthGuard],
        'children': [
            {
                'path': 'index',
                "loadChildren": ".\/pages\/default\/dashboard\/dashboard.module#DashboardModule"
            },
            {
                "path": "calendar",
                "loadChildren": ".\/pages\/default\/calendar\/calendar.module#CalendarPageModule"
            },
            {
                "path": "profile",
                "loadChildren": ".\/pages\/default\/profile\/profile.module#ProfileModule"
            },
            {
                "path": "artists",
                "loadChildren": ".\/pages\/default\/artists\/artists.module#ArtistsModule"
            },
            {
                "path": "editArtist",
                "loadChildren": ".\/pages\/default\/editArtist\/editArtist.module#EditArtistModule"
            },
            {
                "path": "bookings",
                "loadChildren": ".\/pages\/default\/bookings\/bookings.module#BookingsModule"
            },
            {
                "path": "editBooking",
                "loadChildren": ".\/pages\/default\/editBooking\/editBooking.module#EditBookingModule"
            },
            {
                "path": "contacts",
                "loadChildren": ".\/pages\/default\/contacts\/contacts.module#ContactsModule"
            },
            // {
            //   'path': '',
            //   'redirectTo': 'index',
            //   'pathMatch': 'full',
            // },
        ],
    },
    {
        'path': '**',
        'redirectTo': 'index',
        'pathMatch': 'full',
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ThemeRoutingModule { }


// WEBPACK FOOTER //
// ./src/app/theme/theme-routing.module.ts